import { useEffect, useState } from 'react';
import { getSettings, updateSettings, subscribeSettings } from '../utils/settings';

/**
 * useSettings — React hook for the user-settings store.
 * Returns [settings, update] where update accepts a partial patch object.
 */
export default function useSettings() {
  const [settings, setSettings] = useState(getSettings);

  useEffect(() => {
    return subscribeSettings(setSettings);
  }, []);

  return [settings, updateSettings];
}
